import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import ResumenDeProyecto from "./ResumenDeProyecto";

import ListItem from "@material-ui/core/ListItem";
// import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Mail from "@material-ui/icons/Mail";

const ListaProyectos = ({ proyectosUsuario }) => {

  return (
    <div>
      {proyectosUsuario &&
        proyectosUsuario.map(project => {
          let iniciales = project.authorInitials;
          return (
            <Fragment key={project.id}>
              <Link to={"/project/" + project.id} key={project.id}>
                <ListItem style={{borderBottom: "solid 1px silver"}}>
                  <div>
                    <Avatar style={{width: "30px", height: "30px", fontSize: "12px", background: `${project.color}`}} > {iniciales} </Avatar>
                  </div>
                  <ResumenDeProyecto project={project} />
                  <ListItemSecondaryAction>
                    <IconButton aria-label="Delete">
                      <Avatar className="grey" style={{width: "30px", height: "30px"}} >
                        <Mail style={{fontSize: "15px"}}  />
                      </Avatar>
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </Link>
            </Fragment>
          );
        })}
    </div>
  );
};

export default ListaProyectos;
